import * as React from 'react';
import { clsx } from 'clsx';
import { Button, UIHeading5, UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import { CloseButton } from '../components/CloseButton';
import * as styles from './MotivationPopupDesktop.css';

export interface IMotivationPopupDesktopProps {
  isVisible: boolean;
  onClose(): void;
  onLogin(): void;
  onRegister(): void;
}

export const MotivationPopupDesktop: React.VFC<IMotivationPopupDesktopProps> = ({
  isVisible,
  onClose,
  onLogin,
  onRegister,
}) => {
  return (
    <div
      className={clsx(styles['container'], isVisible && styles['container--visible'])}
      data-testid="MotivationPopupDesktop"
    >
      <div className={styles['tooltip']}>
        <div className={styles['button-close']}>
          <CloseButton onClick={onClose} />
        </div>
        <div className={styles['header']}>
          <IconFunctionalSuccess16 color="icon-positive-default" />
          <UIHeading5>Добавлено в избранное</UIHeading5>
        </div>
        <div className={styles['content']}>
          <div className={styles['text']}>
            <UIText2>Войдите, для просмотра избранного с любого устройства</UIText2>
          </div>
          <div className={styles['buttons']}>
            <Button onClick={onLogin} size="XS" type="button">
              Войти
            </Button>
            <Button onClick={onRegister} size="XS" theme="fill_white_primary" type="button">
              Зарегистрироваться
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
